import { isValidToothNumber } from '../../../utils/finding';
import {
  mixpanelEvents,
  // eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent}
  trackEvent as trackEventDep,
  useTrackEvent,
} from '../../../utils/mixpanel';
import AnnotatorConstants, {
  IMAGE_ROWS_DEFAULT,
  IMAGE_ROWS_FMX,
  IMAGE_ROW_COUNT_DEFAULT,
  IMAGE_ROW_COUNT_FMX,
  IMAGE_ROW_COUNT_STRIP,
} from '../annotator.constants';

export const populateCurrentlyRotatingImages = (rotationStore: {
  // eslint-disable-next-line @typescript-eslint/ban-types -- Don't use `{}` as a type. `{}` actually means "any non-nullish value".
  [x: string]: {};
}) => ({
  images: Object.keys(rotationStore)
    .filter((imgId) => rotationStore[imgId] !== 0)
    .map((imgId) => ({
      rotation: rotationStore[imgId],
      imageId: imgId,
    })),
  imageIds: Object.keys(rotationStore).filter(
    (imgId) => rotationStore[imgId] !== 0,
  ),
});

export const trackRotateButtonClick = (input: {
  patientId: string;
  user: any;
  objectId: string;
}) => {
  // eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent}
  trackEventDep(mixpanelEvents.rotateImageClick, input.user, {
    patientId: input.patientId,
    objectId: input.objectId,
  });
};

export const useTrackRerunAnalysisClick = () => {
  const { trackEvent } = useTrackEvent();
  const trackRerunAnalysisClick = ({
    patientId,
    numberOfImages,
    rerunSource,
  }: {
    patientId: string;
    numberOfImages: number;
    rerunSource: string;
  }) => {
    trackEvent(mixpanelEvents.rerunAnalysis, {
      patientId,
      numberOfImages,
      rerunSource,
    });
  };
  return { trackRerunAnalysisClick };
};

export const calculateImageRows = (
  currentImageFilter: string | number,
  imageCount?: number,
) => {
  if (
    currentImageFilter === AnnotatorConstants.ODONTOGRAM ||
    (!!currentImageFilter && isValidToothNumber(currentImageFilter))
  ) {
    if (imageCount) {
      const numRows = Math.ceil(imageCount / IMAGE_ROW_COUNT_DEFAULT);
      return {
        imagesPerRow: Math.min(IMAGE_ROW_COUNT_DEFAULT, imageCount),
        numberOfRows: numRows,
      };
    }

    return {
      imagesPerRow: IMAGE_ROW_COUNT_STRIP,
      numberOfRows: IMAGE_ROWS_DEFAULT,
    };
  }
  if (
    currentImageFilter === AnnotatorConstants.FMX ||
    currentImageFilter === AnnotatorConstants.OTHER
  ) {
    return {
      imagesPerRow: IMAGE_ROW_COUNT_FMX,
      numberOfRows: IMAGE_ROWS_FMX,
    };
  }
  return {
    imagesPerRow: IMAGE_ROW_COUNT_DEFAULT,
    numberOfRows: IMAGE_ROWS_DEFAULT,
  };
};
